module.exports = __webpack_public_path__ + "static/logo_full-1b952c2edb66d55ac50b64705e65930e.png";